import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MspSemantixLogoComponent } from './msp-semantix-logo.component';

@NgModule({
	declarations: [],
	imports: [MspSemantixLogoComponent],
	exports: [MspSemantixLogoComponent],
})
export class MspSemantixLogoModule {}
